import { Class } from "types";
import { api } from "../api";
import { NetworkError } from "../networkError";

interface FetchClassParams {
  token: string;
  classId: string;
}

const fetchClass = async ({ token, classId }: FetchClassParams): Promise<Class> => {
  const response = await api.get(`/classes/${classId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const class_ = response.data;

  if (class_) {
    return class_;
  } else {
    throw new NetworkError();
  }
};

export { fetchClass };
